<template v-if="products">
  <div class="pop_sales pop_sales_exit popup_wrap" style="display:block" >
    <div class="popup_in">
      <div class="popup" :style="products.length == 2 ? 'max-width:600px': products.length == 1 ? 'max-width:350px;': ''">
        <!-- <div class="popup_close stay_close close-animate">
          <a href="javascript:void(0);" @click="closePop()">
            <close />
          </a>
        </div> -->
        <div class="pp_prod_bottom">
         
          <h2 class="title25" v-if="!instock"  > חסר לנו היום <span style="font-weight: 900;display: inline;color: black;" v-html="title"></span><br> <span v-if="typeof products == 'undefined' ||  products.length == 0">נשתדל להשיג לך עד שהמשלוח יצא...</span> <span v-if="products.length > 0">אפשר לבחור מאחד המוצרים הבאים במקום :</span></h2>
          <h2 class="title25" v-if="instock" > יש לנו במלאי {{instock}} <span style="font-weight: 900;display: inline;color: black;" v-html="title"></span> מתוך ה {{wanted}} שבחרת<br> <span v-if="products.length > 0">אפשר לבחור מאחד המוצרים הבאים במקום:</span></h2>
          <div class="pp_slide_wrap small-arrows" :class="{'slide_2' : products.length == 2 }">
            <div class="arrow_r ease" style="display:none;">
              <a href="javascript:void(0);" @click.prevent="prev">
                <arrow-right />
              </a>
            </div>
            <div class="arrow_l ease" style="display:none;">
              <a href="javascript:void(0);" @click.prevent="next">
                <arrow-left />
              </a>
            </div>
            <div class="pp_slide clearfix" v-if="products">
              <slick
                ref="slick"
                :options="slickOptions"
                v-if="products && slickOptions.nextArrow && slickOptions.prevArrow"
              >
                <Product
                  v-bind:product="product"
                  v-bind:index="index"
                  v-bind:is_popup="true"
                  v-for="(product, index) in (products)"
                  :key="product.id"
                ></Product>
              </slick>
            </div>
          </div>
          <div class="flex flex--content--center">
            <div class="bt_green  ease" style="margin:0 10px;" v-if="typeof products !='undefind' && products && products.length > 0">
                <a href="javascript:void(0);" @click="submitOrder" style="width:280px;">
                    בחרתי, אפשר להמשיך
                </a>
            </div>
            <div class="bt_green  ease" style="margin:0 10px;">
                <a href="javascript:void(0);" @click="submitOrder" style="width:280px;">
                   {{btnText}}
                </a>
            </div>

          </div>
              </div>
      </div>
    </div>

  </div>
</template>

<script>
import Close from "../../assets/img/close.svg";
import arrowLeft from "../../assets/img/arrow_l.svg";
import arrowRight from "../../assets/img/arrow_r.svg";
import Product from "../Product/Product";
import Slick from "vue-slick";
import { mapState, mapActions } from "vuex";
export default {
  props: ["products","title","instock","wanted"],
  data() {
    return {
      disclaimer_pop: wpData.globalOptions.sale_banner_text,
      slickOptions: {
        rtl: true,
        dots: false,
        infinite: true,
        arrows: true,
        centerMode: false,
        nextArrow: false,
        prevArrow: false,
        slidesToShow: Object.values(this.products).length < 3 ? (this.products.length == 2 ? 2:1) : 3,
        slidesToScroll: Object.values(this.products).length < 3 ? (this.products.length == 2 ? 2:1) : 3,
        autoplay: false,
        autoplaySpeed: 3000,
        responsive: [
          {
            breakpoint: 992,
            settings: {
              slidesToShow: 2
            }
          },
          {
            breakpoint: 800,
            settings: "unslick"
          }
        ]
      }
    };
  }, 
  mounted() {

      
    let r_arrow = $(".arrow_l");
    let l_arrow = $(".arrow_r");
    this.slickOptions.nextArrow = r_arrow;
    this.slickOptions.prevArrow = l_arrow;
  },
  computed: {
    btnText(){
      if (typeof this.products !='undefind' && this.products && this.products.length > 0) {
        return "לא חשוב, אסתדר בלי";
      }
      else{
        return "הבנתי";

      }
    }
  },
  methods: {
    next() {
      //this.$refs.slick.next();
    },
    prev() {
      //  this.$refs.slick.prev();
    },
    closePop() {
    
      this.$emit('close');
      this.$root.$emit('popupClosed');
      //this.$modal.hide("exitsales-pop");
    },
    submitOrder(){

        this.closePop();
    }
  
  },

  components: {
    Close,
    Slick,
    arrowLeft,
    arrowRight,
    Product
  }
};
</script>

<style scoped>
.title25 {
    font-size: 22px;
    color: black;
    font-weight: 400;
    line-height: 28px;
    margin-bottom: 20px;
}


</style>